import { SENTIMENT } from "../constants/retention/constants";

/**
 * Initializes the sentiment summary on basis of sentiment response and sub-categorization by sentiment score.
 *
 * @param {Number} surveyResponseRate
 * @param {Number} sentimentScore
 * @returns {String}
 */
export const initializeSentimentSummary = (
  surveyResponseRate = 0,
  sentimentScore
) => {
  if (!surveyResponseRate) {
    return SENTIMENT["No Data"].value;
  }

  switch (true) {
    case sentimentScore >= 85 && sentimentScore <= 100:
      return SENTIMENT["Strongly Positive"].value;
    case sentimentScore >= 70 && sentimentScore <= 84:
      return SENTIMENT.Positive.value;
    case sentimentScore >= 30 && sentimentScore <= 69:
      return SENTIMENT.Neutral.value;
    case sentimentScore >= -10 && sentimentScore <= 29:
      return SENTIMENT.Negative.value;
    case sentimentScore >= -100 && sentimentScore <= -9:
      return SENTIMENT["Strongly Negative"].value;
    default:
      return SENTIMENT["No Data"].value;
  }
};
